module.exports = __webpack_public_path__ + "img/bg.338ebf90.png";